/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid } from '@mui/material';
import React, { useState } from 'react';
import Shell from '../../common/components/Shell/Shell';
import { useAppSelector } from '../../infra/hooks';
import AnnouncementPresenter from './AnnouncementPresenter';
import DTOAnnouncement from './DTOAnnouncement';
import { useTranslation } from 'react-i18next';

function AnnouncementController() {
  const [announcementData, setannouncementData] = useState([]);
  const [textfilterData, setTextfilterData] = useState('');
  const { t, i18n } = useTranslation();
  const isLoading = useAppSelector(
    (state) => state.announcementSlice.annoucementLoader,
  );
  function callBackFunc(data: any) {
    setannouncementData(data);
  }

  async function callBackTextfilter(Data: any) {
    setTextfilterData(Data);
  }

  return (
    <>
      <Shell>
        <Grid
          container
          style={{
            maxWidth: 'auto',
            marginLeft: '7.25em',
          }}
        >
          <AnnouncementPresenter
            announcementData={announcementData}
            setTextFilterSearch={callBackTextfilter}
            isLoading={isLoading}
            trans={t}
            i18n={i18n}
          />
        </Grid>
      </Shell>
      <DTOAnnouncement
        setAnnouncementData={callBackFunc}
        settextFilter={textfilterData}
      />
    </>
  );
}
export default AnnouncementController;
